const overrideRadio = (theme) => {
  theme.overrides.MuiRadio = {
    root: {
      color: theme.colorPalette.green_75,
      padding: 4
    },
    disabled: {
      color: theme.colors.white
    }
  };
};

export default overrideRadio;
